import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "250",
  height: "250",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M15,6c-1.11-1.3-3.14-1.64-4.7-2.07s-2.88-1-4.38-1.38A28,28,0,0,0,2.8,1.78c-.42,0-.48.6,0,.7A50.83,50.83,0,0,1,10,4.67c1.35.4,3.32.78,4.21,1.87.45.55-.5,10.05-.64,12.93,0,.92,0,1.85-.12,2.75-.09.56,0,.84-1.55.51A52.1,52.1,0,0,1,3.56,19.6c-.48-.28-1.09-.68-1.21-1.22-.08-.39-.19-2.13-.21-2.85C1.83,5.85,2.42,2.85,2,2.64s-.43.17-.44.6C1.46,5.15,1,16.45,1.39,18.57A3.05,3.05,0,0,0,3,20.49,41,41,0,0,0,8,22.64c1.28.52,4.58,1.8,5.81,1.19s.86-2.44.94-4.31C15.41,7.93,15.56,6.67,15,6Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22.72,7.8C22.8,5.93,23,.88,21.25.16,20.2-.28,4.58.34,2.8.6A.38.38,0,0,0,2.45,1c.09.28,2.76.44,4.32.81.1,0,5.13,1.26,6.42,1.65C18,5,17.64,4.73,17.76,6.34c.06.83,0,1.74.06,2.37.08,1,.72,10.69.24,11.4s-2.24,0-2.83.32c-.39.19-.2.63.15.66,1.07.1,2.7.32,3.32-.54.3-.41.2-1,.38-1.83a16.43,16.43,0,0,0,.06-3c0-2.61-.05-4.61-.18-7.11-.07-1.15.1-3-.46-4.13A1.24,1.24,0,0,0,17.93,4c-.14-.07-3.16-1.11-4.46-1.45C11.83,2.1,6.62,1.1,6.25,1c.1,0,14.59.12,14.67.24,1.44,2.17.34,11.09.49,13.42a22.05,22.05,0,0,1,.17,3.86c-1.32.15-1.33-.06-1.49-.06a.33.33,0,0,0-.33.33c0,.39.45.44.83.46a8.87,8.87,0,0,0,1.21,0C22.71,19.13,22.24,18.1,22.72,7.8Z",
        fill: "#86bd4d"
      }),
      _createElementVNode("path", {
        d: "M11.45,9.72c0-.47.26-1.33-.39-1.64C9.68,7.43,8.27,7.51,7,7a12,12,0,0,1-1.82-.51c-.1-.26-.48-.25-.66.09a8.79,8.79,0,0,0-.24,2.21c-.35,1.95-.39,1.95-.18,2.18s.6.23.8.33a42.91,42.91,0,0,0,5.37,2.13c.52,0,.88-.79,1-1.28A11.29,11.29,0,0,0,11.45,9.72Zm-1.07-.08A8,8,0,0,1,10,12.12a47.85,47.85,0,0,1-5.18-1.89A20.9,20.9,0,0,0,5,7.12a14.09,14.09,0,0,0,1.63.54c1.19.59,2.66.69,3.8,1.24C10.28,9,10.4,9.5,10.38,9.64Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M8,14.83c-.84-.21-2.22-.44-3.57-.83v0h0c.11,0-.28-.14-.38.17s.12.35.78.7a7.36,7.36,0,0,0,2.66,1c3.51.64,2.41.66,2.87.62a.34.34,0,0,0,.34-.34C10.66,15.64,8.73,15,8,14.83Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }